import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from 'react-select';

import {
  ChangePayScheduleEditScreenContainer,
  DateOfPaymentContainer,
  PaymentDateHeader,
  PayPlanButtonContainer,
  PayScheduleEditHeader,
  RequiredField,
  SelectPayMethodHeader,
  SelectPayPlanHeader,
  StyledPayDateInput,
} from './styles';

import PayScheduleTable from './payScheduleTable';
import FundingInstruments from './fundingInstruments';
import { setNewStatementPlanSchedule, setStatementDateToPay } from './accountDetailsReducer';
import { setPaymentInstrument } from '../make-payment/step-two-amount/makePaymentStepTwoReducer';
import { handleStatementPayDateChange } from './utils';
import Loader from '../../common/loader';
import { getText } from '../../../utils/i18n';

export const EditStatementPaySchedule = (props) => {
  const {
    account,
    dispatch,
    isLoading,
    newStatementPlan,
    statementPayPlanDateToPay,
    statementPayPlanOptions,
    i18n,
  } = props;
  const payPlanOptionsMapped = statementPayPlanOptions.map((plan) => {
    return { ...plan, label: plan.name, value: plan.payPlanCd };
  });
  const handlePlanScheduleChange = (plan) => {
    if (plan.payPlanCd === 'Direct Pay In Full-NB') {
      dispatch(setPaymentInstrument(null));
      dispatch(setStatementDateToPay(''));
      //if they previously had set their payment we want to null that out.
    }
    dispatch(setNewStatementPlanSchedule(plan));
  };

  return (
    <ChangePayScheduleEditScreenContainer>
      <PayScheduleEditHeader>Payment Schedule</PayScheduleEditHeader>
      <SelectPayPlanHeader>
        Select your new payment schedule
        {isLoading && <Loader loaderwidth="20px" loaderheight="20px" />}
      </SelectPayPlanHeader>
      <PayPlanButtonContainer>
        <Select
          id="payPlanSelector"
          options={payPlanOptionsMapped}
          value={newStatementPlan}
          isDisabled={isLoading}
          defaultValue={{ label: '-- Select a Plan --', value: 'default' }}
          onChange={handlePlanScheduleChange}
        />
      </PayPlanButtonContainer>
      {newStatementPlan?.payPlanCd?.includes('Automated') && (
        <div
          dangerouslySetInnerHTML={{
            __html: getText(i18n, 'changePayPlan.automatedPlanDescription', ''),
          }}
        ></div>
      )}
      {newStatementPlan ? (
        <div>
          <h1>Your New Payment Schedule</h1>
          {newStatementPlan?.payPlan?.schedule && (
            <PayScheduleTable schedule={newStatementPlan.payPlan.schedule} />
          )}
        </div>
      ) : null}
      <DateOfPaymentContainer>
        {newStatementPlan &&
        newStatementPlan.payPlanCd !== 'Direct Pay In Full-NB' &&
        newStatementPlan.payPlan.dayOfMonthInd !== 'No' ? (
          <>
            <PaymentDateHeader>
              What day of the month do you want to pay?
              {newStatementPlan.payPlan.dayOfMonthInd === 'Required' && (
                <RequiredField> *</RequiredField>
              )}
            </PaymentDateHeader>
            <StyledPayDateInput
              id="payDateSelect"
              max="31"
              min="1"
              value={statementPayPlanDateToPay}
              onChange={(e) => handleStatementPayDateChange(e.target.value, dispatch)}
            />
          </>
        ) : null}
      </DateOfPaymentContainer>

      {newStatementPlan && newStatementPlan.payPlanCd.includes('Automated') ? (
        <>
          <SelectPayMethodHeader>Select your payment method.</SelectPayMethodHeader>
          <FundingInstruments payScheduleAccount={account} />
        </>
      ) : null}
    </ChangePayScheduleEditScreenContainer>
  );
};
EditStatementPaySchedule.propTypes = {
  account: PropTypes.object,
  dispatch: PropTypes.func,
  i18n: PropTypes.object,
  isLoading: PropTypes.bool,
  statementPayPlanDateToPay: PropTypes.string,
  statementPayPlanOptions: PropTypes.array,
  newStatementPlan: PropTypes.object,
};
export const mapStateToProps = (state) => ({
  i18n: state.i18nSlice.i18n,
  billingAccounts: state.billingSlice.billingAccounts,
  statementPayPlanDateToPay: state.accountDetailsSlice.statementPayPlanDateToPay,
  statementPayPlanOptions: state.accountDetailsSlice.statementPayPlanOptions,
  isLoading: state.accountDetailsSlice.isLoading,
  newStatementPlan: state.accountDetailsSlice.newStatementPlan,
});

export default connect(mapStateToProps)(EditStatementPaySchedule);
